import SideBarNav from '../../ui/components/SideBarNav';
import MainContent from './MainContent';
import SideNav from './SideNav';

function Main() {
  return (
    <section className="grid md:grid-cols-4 gap-9">
      <SideNav />
      {/* <SideBarNav title="Browse Policies" /> */}
      <MainContent />
    </section>
  );
}

export default Main;
